/** biome-ignore-all lint/security/noDangerouslySetInnerHtml: // todo check this later */
"use client";

import Link from "next/link";

interface Props {
  id: string;
  text: string;
}

const TocLink = ({ id, text }: Props) => {
  return (
    <Link
      className="text-sm font-medium hover:text-brand-blue-500 transition-colors"
      dangerouslySetInnerHTML={{ __html: text }}
      href={`#${id}`}
      onClick={(e) => {
        e.preventDefault();
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
        window.history.pushState(null, "", `#${id}`);
      }}
    />
  );
};

export default TocLink;
